import { DataView } from "primereact/dataview";
import { PERMISSION_TRAINING_SESSIONS, PERMISSION_TRAINING_TEACHERS } from "../../../../permissions";
import { classNames } from "primereact/utils";
import MeaLink from "../../../../components/MeaLink";
import { useEffect, useState } from "react";
import MeaLoadingContent from "../../../../components/MeaLoadingContent";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import MeaTeacherAvatar from "../../components/MeaTeacherAvatar";
import MeaAttendancesProgressBar from "../../components/MeaAttendancesProgressBar";
import MeaAttendancesProgressBar2 from "../../components/MeaAttendancesProgressBar2";

const TodaySessionsComponent = ({ todaySessions, objectQuery, schoolId, trainingId }) => {
  const { hasPermission } = useAuthContext();
  const [sessions, setSessions] = useState();
  const canViewSessions = hasPermission(PERMISSION_TRAINING_SESSIONS.LIST) || hasPermission(PERMISSION_TRAINING_SESSIONS.GET);

  useEffect(() => {
    if (todaySessions) {
      setSessions(todaySessions);
    }
  }, [todaySessions]);

  if (!canViewSessions) {
    return null;
  }

  const todaySessionsTemplate = (session, index) => {
    return (
      <div className={classNames('col-12', { 'bg-blue-50': session?.attendances?.length > 0 })} key={session.id}>
        <div className={classNames('flex flex-column xl:flex-row xl:align-items-start gap-2', { 'border-top-1 surface-border': index !== 0 })}>
          <MeaLink to={
            "/school/" +
            schoolId +
            "/admin/trainings/" +
            trainingId +
            "/sessions/" +
            session.id
          }
            permission={PERMISSION_TRAINING_SESSIONS.GET} isRipple={true}>
            <div className="flex flex-column pt-2 sm:flex-row justify-content-between align-items-start flex-1 gap-2">
              <div className="flex sm:flex-column align-items-start gap-3 sm:gap-2">
                <MeaTeacherAvatar
                  teacher={session.teacher}
                  substitute={session?.schedule_item?.teacher}
                  permission={PERMISSION_TRAINING_TEACHERS.GET}
                  noNavigation={true}
                />
                {session?.schedule_item?.teacher && session?.schedule_item?.teacher?.id !== session.teacher?.id && <span className="text-left text-xs text-500">Remplace {session?.schedule_item?.teacher?.member?.name}</span>}
              </div>
              <div className="flex flex-column align-items-start sm:align-items-end gap-1">
                <div className="text-left sm:text-right text-l text-900">{session?.schedule_item?.classe?.name}</div>
                <span className="text-left sm:text-right text-l text-500">{session?.classroom?.name}</span>
              </div>
            </div>
          </MeaLink>
        </div>
        <div className="flex w-full">
          <MeaAttendancesProgressBar
            attendances={session?.attendances}
            showValues={false}
            showLegends={false}
          />
        </div>
      </div>
    );
  }

  const listTemplate = (items) => {
    if (!items || items.length === 0) return (
      <span className="text-500">Pas de séances aujourd'hui.</span>
    );
    let attendances = [];
    items.forEach((session) => {
      attendances = attendances.concat(session.attendances);
    });
    let list = items.map((session, index) => {
      return todaySessionsTemplate(session, index);
    });
    return <div className="grid grid-nogutter">
      <MeaAttendancesProgressBar2 attendances={attendances} showMeter={false} />
      {list}
    </div>;
  };

  return (
    <>
      <MeaLoadingContent objectQuery={objectQuery}>
        <DataView value={sessions} listTemplate={listTemplate} emptyMessage="Pas de séances." />
      </MeaLoadingContent>
    </>
  );
}

export default TodaySessionsComponent;